import React from "react"
import { FooterLink } from "components/FooterLink"

const Footer = () => {
    const getYear = new Date().getFullYear()

    return (
        <footer>
            <div className="footer-faded-line"></div>
            <div className="p-3 d-flex align-items-center justify-content-center">
                <p>EnergilityDX by Crawford Consulting  |  © {getYear} Crawford Consulting. All Rights Reserved</p>
                <FooterLink linkTo="https://energilitydx.com/privacy/" text="Privacy"/>
                <FooterLink linkTo="https://energilitydx.com/terms/" text="Terms"/>
                <FooterLink linkTo="mailto://support@energilitydx.com" text="Email Support"/>
            </div>
        </footer>
    )
}

export default Footer
